export const pushToDL = (data: any, useParent: boolean = false) => {
  try {
    const targetWindow = useParent && window.parent ? window.parent : window
    const dataLayer = (targetWindow as any)?.dataLayer || []
    return dataLayer.push(data)
  } catch (err) {
    return console.error("error in pushToDataLayer", err)
  }
}
